import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@localina/core';
import { Link } from 'react-router-dom';
import { Path } from '../../../enums';

export const Done: React.FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <p className="auth-layout__text">{t('register.confirmation')}</p>
            <Link to={Path.LOGIN}>
                <Button label={t('register.buttons.login')} />
            </Link>
        </>
    );
};
